(function () {
  // Mobile menu
  var burger = document.querySelector('[data-hx-burger]');
  var mobileMenu = document.querySelector('[data-hx-mobile-menu]');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      mobileMenu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', mobileMenu.classList.contains('is-open'));
    });
  }

  // Search toggle
  var searchToggle = document.querySelector('[data-hx-search-toggle]');
  var searchBar = document.querySelector('[data-hx-search-bar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('is-open');
      if (searchBar.classList.contains('is-open')) {
        var input = searchBar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  // AJAX cart (drawer + cart page + upsells)
  var HxCart = {
    drawer: function () { return document.querySelector('[data-hx-cart-drawer]'); },
    open: function () { var d = this.drawer(); if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('hx-no-scroll'); } },
    close: function () { var d = this.drawer(); if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('hx-no-scroll'); } },
    refresh: function (openAfter) {
      var self = this;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('.hx-cart-count, [data-hx-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      });
      if (this.drawer()) {
        fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
          if (!j['cart-drawer']) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = j['cart-drawer'];
          var fresh = tmp.querySelector('[data-hx-cart-drawer]');
          var cur = self.drawer();
          if (fresh && cur) {
            var wasOpen = cur.classList.contains('is-open');
            cur.innerHTML = fresh.innerHTML;
            if (wasOpen || openAfter) self.open();
          }
        });
      } else if (openAfter) {
        window.location.href = '/cart';
      }
      var mainCart = document.getElementById('MainCart');
      if (mainCart) {
        fetch(window.location.pathname).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('MainCart');
          if (fresh) mainCart.innerHTML = fresh.innerHTML;
        });
      }
    },
    change: function (line, qty) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function () { HxCart.refresh(false); });
    },
    add: function (variantId) {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) })
        .then(function () { HxCart.refresh(true); });
    }
  };
  window.HxCart = HxCart;
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-hx-cart-open]');
    if (openBtn && HxCart.drawer()) { e.preventDefault(); HxCart.refresh(false); HxCart.open(); return; }
    if (e.target.closest('[data-hx-cart-close]')) { HxCart.close(); return; }
    var qtyBtn = e.target.closest('[data-hx-qty-change]');
    if (qtyBtn) { HxCart.change(parseInt(qtyBtn.dataset.hxLine, 10), Math.max(0, parseInt(qtyBtn.dataset.hxQty, 10))); return; }
    var rm = e.target.closest('[data-hx-remove]');
    if (rm) { HxCart.change(parseInt(rm.dataset.hxLine, 10), 0); return; }
    var ups = e.target.closest('[data-hx-upsell-add]');
    if (ups) { ups.disabled = true; ups.textContent = 'ADDING…'; HxCart.add(parseInt(ups.dataset.hxUpsellAdd, 10)); return; }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-hx-qty-input-line]');
    if (input) HxCart.change(parseInt(input.dataset.hxLine, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') HxCart.close(); });

  // AJAX add to cart: intercept product form submit, open drawer
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-hx-product-form]');
    if (!form || !HxCart.drawer()) return;
    e.preventDefault();
    var btn = form.querySelector('[data-hx-add-btn]');
    if (btn) { btn.disabled = true; btn.textContent = 'ADDING…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function () { HxCart.refresh(true); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.hxAddText || 'ADD TO CART'; }
      });
  });

  // Sticky add to cart bar (shows once main button scrolls out of view)
  var stickyBar = document.querySelector('[data-hx-sticky-atc]');
  var mainAtcBtn = document.querySelector('[data-hx-add-btn]');
  if (stickyBar && mainAtcBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var passed = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      stickyBar.classList.toggle('is-visible', passed);
      stickyBar.setAttribute('aria-hidden', passed ? 'false' : 'true');
    }, { threshold: 0 }).observe(mainAtcBtn);
    var stickyBtn = stickyBar.querySelector('[data-hx-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('[data-hx-product-form]');
        if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
      });
    }
  }

  // Logo marquee: duplicate items until each half fills the container (seamless infinite loop)
  function hxFillMarquees() {
    document.querySelectorAll('.hx-logo-marquee').forEach(function (mq) {
      var track = mq.querySelector('.hx-logo-marquee__track');
      if (!track || track.children.length < 2 || track.dataset.hxFilled) return;
      var g1 = track.children[0], g2 = track.children[1];
      var gw = g1.getBoundingClientRect().width;
      var cw = mq.getBoundingClientRect().width;
      if (!gw || !cw) return;
      track.dataset.hxFilled = '1';
      var items = Array.prototype.slice.call(g1.children);
      var reps = Math.ceil(cw / gw);
      for (var r = 1; r < reps; r++) {
        items.forEach(function (it) {
          g1.appendChild(it.cloneNode(true));
          g2.appendChild(it.cloneNode(true));
        });
      }
    });
  }
  hxFillMarquees();
  document.addEventListener('shopify:section:load', hxFillMarquees);

  // Scroll reveal
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.hx-reveal').forEach(function (el) { observer.observe(el); });
  } else {
    document.querySelectorAll('.hx-reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Product page: thumbnail swap
  document.querySelectorAll('[data-hx-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-hx-main-image]');
      if (main) main.src = thumb.dataset.hxFull;
    });
  });

  // Product page: variant selection -> update hidden id + price
  var productForm = document.querySelector('[data-hx-product-form]');
  if (productForm) {
    var variantsJson = document.querySelector('[data-hx-variants]');
    if (variantsJson) {
      var variants = JSON.parse(variantsJson.textContent);
      var selects = productForm.querySelectorAll('[data-hx-option]');
      selects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
          var match = variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === chosen[i]; });
          });
          var idInput = productForm.querySelector('input[name="id"]');
          var priceEl = document.querySelector('[data-hx-price]');
          var btn = productForm.querySelector('[data-hx-add-btn]');
          if (match) {
            idInput.value = match.id;
            if (priceEl) priceEl.textContent = (match.price / 100).toLocaleString(undefined, { style: 'currency', currency: window.hxCurrency || 'GBP' });
            if (btn) {
              btn.disabled = !match.available;
              btn.textContent = match.available ? btn.dataset.hxAddText : btn.dataset.hxSoldOutText;
            }
          }
        });
      });
    }
  }
})();
